import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from '../time.service';
import { MatDialog, MatPaginator } from '@angular/material';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { CreateCreditNoteComponent } from '../create-credit-note/create-credit-note.component';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { DateTime } from "luxon";
import { EpodsPrevComponent } from '../epods-prev/epods-prev.component';
import { EditConsolidatedInvoiceComponent } from '../edit-consolidated-invoice/edit-consolidated-invoice.component';
import { EpodPreviewComponent } from '../epod-preview/epod-preview.component';




@Component({
  selector: 'app-consolidated-invoice',
  templateUrl: './consolidated-invoice.component.html',
  styleUrls: ['./consolidated-invoice.component.scss']
})
export class ConsolidatedInvoiceComponent implements OnInit {
  @ViewChild('selectSinDialog', { static: true }) selectedSinDialog: TemplateRef<any>;
  dialogRef: any;
  selectedShipper: any;
  selectedSinarray: any;


  shippers: any;
  fromDate: any;
  toDate: any;
  carriers: any;
  statuses = [
    {
      name: 'Pending',
      value: 'PENDING',
      isActive: false,
      activeIcon: 'assets/pending_hover_icon.svg',
      inactiveIcon: 'assets/pending_icon.svg',
      backgroundColor: '#AED6F1',
      count: 0,
      total: 0
    },
    {
      name: 'Approved By Checker',
      value: 'APPROVED_BY_CHECKER',
      isActive: false,
      activeIcon: 'assets/approved_by_checker_hover_icon.svg',
      inactiveIcon: 'assets/approved_by_checker_icon.svg',
      backgroundColor: '#000',
      count: 0,
      total: 0
    },
    {
      name: 'Approved By Lead',
      value: 'APPROVED_BY_LEAD',
      isActive: false,
      activeIcon: 'assets/approved_by_lead_hover_icon.svg',
      inactiveIcon: 'assets/approved_by_lead_icon.svg',
      backgroundColor: 'red',
      count: 0,
      total: 0
    },
    {
      name: 'Disapproved',
      value: 'DISAPPROVED',
      isActive: false,
      activeIcon: 'assets/disapproved_hover_icon.svg',
      inactiveIcon: 'assets/disapproved_icon.svg',
      backgroundColor: 'yellow',
      count: 0,
      total: 0
    }
  ];

  selectedStatus = '';
  plantCode: { plant_code: any; };
  selectedShipperName: any;
  consolidatedInvoiceFilter: any = {};
  uploadType: any;
  showLoader: boolean;
  shipmentDetails: any;
  material_damage_percentage: any;
  material_missing_percentage: any;
  tax_type: any;
  measure_unit: any;
  shipmentType: any;
  materials_array: any;
  snackbar: any;
  valid: any;
  selectedSin: string;
  dialogSelectSinRef: any;
  invoiceNumber = '';
  deleteEpod: any;
  filteredOptions: any = [];
  searchText: string = '';
  constructor(private http: HttpService, private snackBar: SnackbarService, private timeService: TimeService, private events: EventService, private dialog: MatDialog) { }
  dataSource = [];
  displayedColumns = [
    'sno',
    'Date',
    'plantCode',
    'freightAmount',
    'ShipperName',
    'customInvoiceNumber',
    'status',
    'approvedBy',
    'comments',
    'actions'
  ];
  carrierId: Subscription;

  totalInvoices = 0;
  filters: any = {};
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  ngOnInit() {

    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getConsolidatedInvoices();
        this.getShippers();
        this.getConsolidatedStatus();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
    let currendateTime: any = DateTime.local().minus({ days: 15 });
    this.fromDate = new Date(currendateTime);
    this.toDate = new Date()
    this.onStatusCardClick('PENDING');
    this.getShippers();
    // this.getConsolidatedInvoices();
    this.getConsolidatedStatus();
  }
  getConsolidatedInvoices(filter: any = {}) {
    filter = {
      ...(this.fromDate && { from: DateTime.fromJSDate(this.fromDate).startOf("day").toUTC() }),
      ...(this.toDate && { to: DateTime.fromJSDate(this.toDate).endOf("day").toUTC() }),
      ...(this.plantCode && { plant_code: this.plantCode.toString() }),
      ...(this.selectedStatus && { status: this.selectedStatus }),
      ...(this.selectedShipper && { shipper: this.selectedShipper }),
      ...(this.invoiceNumber && this.invoiceNumber.length > 3 && { invoice_no: this.invoiceNumber })
    };
    filter.limit = this.paginator.pageSize || 10;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.http.get('v2/carrier_consolidated_invoice/get_all', filter, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const res = data.data.data;
          this.totalInvoices = data.data.count;
          this.dataSource = res.map((item, i) => {
            return {
              _id: item._id,
              sno: i + 1,
              date: this.timeService.toShortDateTime24(item.created_at),
              plantCode: item.plant_code,
              freightAmount: item.final_amount,
              shipperName: item.shipper.parent_name,
              customInvoiceNumber: item.custom_bill_number,
              carrier_comments: item.carrier_comments,
              shipper_comments: item.shipper_comments ? item.shipper_comments : '',
              status: item.status,
              pdfLink: item.pdf_link || '',
              approvedBy: item.approved_by && item.approved_by.second_approval ? 'Lead' : item.approved_by && item.approved_by.first_approval ? 'Checker' : '-',
              item,
              attachments: item.attachments,
              fullData: item
            }
          });
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  pageNavigate(event) {
    this.consolidatedInvoiceFilter.limit = event.pageSize;
    this.consolidatedInvoiceFilter.skip = event.pageIndex * event.pageSize;
    this.getConsolidatedInvoices(this.consolidatedInvoiceFilter);
  }

  openCreateDebitDialog(element, type) {
    element.noteType = type;
    this.dialogRef = this.dialog.open(CreateCreditNoteComponent, {
      panelClass: 'icon-outside',
      data: element
    });
  }

  getShippers() {
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.shippers = data.data;
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  selectShipper(element) {
    this.selectedShipper = element._id;
    this.selectedShipperName = element.parent_name;
    this.getConsolidatedInvoices();
  }
  selectStatus(option) {
    this.selectedStatus = option.value;
    this.getConsolidatedInvoices();
  }
  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
  openAttachmentUploader(element, type) {
    this.uploadType = type;
    const payload = {
      url: 'v1/carrier_consolidated_invoice/attachments/',
      _id: element._id,
    };
    this.dialogRef = this.dialog.open(FileUploaderComponent, {
      data: {
        payload,
        type
      }
    });
    this.dialogRef.afterClosed().subscribe(
      (data: any) => {
        console.log(data);
      }
    )
  }

  getShipmentDetails(row) {
    this.http.get('shipment/one?shipmentId=' + row).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {

          this.shipmentDetails = data.data;
          this.shipmentDetails.deleteEpod = this.deleteEpod;
          const dialogRef = this.dialog.open(EpodsPrevComponent, {
            panelClass: 'icon-outside',
            data: this.shipmentDetails
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result && result.refreshInvoice) {
              if (result.tab) {
                this.openShipmentDetails(row, result.tab);
              }
            } else {
              this.shipmentDetails = {};
            }
          });
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
    this.selectedSin = '';
    this.dialogSelectSinRef.close();
  }

  openShipmentDetails(row: any, tab: any) {
    throw new Error('Method not implemented.');
  }
  openselectSInDialog(row) {
    this.selectedSinarray = row.item.shipments;
    this.filteredOptions = this.selectedSinarray.slice();
   
    this.http.get('carrier_consolidated_invoice/getInvoice', { _id: row._id }, 1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          data.data.deleteEpod = row.status === 'APPROVED' ? false : true;
          const dialogRef = this.dialog.open(EpodPreviewComponent, {
            maxWidth: '80vw',
            width: '80%',
            data: data.data,
          });
          dialogRef.afterClosed().subscribe(result => {
          });
        }
      });
  }
  selectSinDialog(selectSinDialog: any): any {
    throw new Error('Method not implemented.');
  }

  download(filter: any = {}) {
    filter = {
      ...(this.fromDate && { from: DateTime.fromJSDate(this.fromDate).startOf("day").toUTC() }),
      ...(this.toDate && { to: DateTime.fromJSDate(this.toDate).endOf("day").toUTC() }),
      ...(this.plantCode && { plant_code: this.plantCode.toString() }),
      ...(this.selectedStatus && { status: this.selectedStatus.toLocaleUpperCase() }),
      ...(this.selectedShipper && { shipper: this.selectedShipper }),
      ...(this.invoiceNumber && this.invoiceNumber.length > 3 && { invoice_no: this.invoiceNumber })
    };
    this.http.post('reports/consolidatedInvoice', filter, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          window.open(data.data.link, "_blank");
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  openInvoiceDetails(row) {
    if(row.status=='DISAPPROVED') {
    } else {
      const dialogRef = this.dialog.open(EditConsolidatedInvoiceComponent, {
        data: row.fullData
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getConsolidatedInvoices();
      });
    }
  }
  applyFilter(filterValue: string) {
    if (!filterValue) {
      this.filteredOptions = this.selectedSinarray.slice();
    } else {
      this.filteredOptions = this.selectedSinarray.filter(inv =>
        inv.do_numbers.some(number =>
          number.toLowerCase().includes(filterValue.toLowerCase())
        )
      );
    }
  }

  // ...

  onStatusCardClick(statusValue: string) {
    const clickedStatus = this.statuses.find(s => s.value === statusValue);
    const previouslySelectedStatus = this.statuses.find(s => s.isActive);
    if (previouslySelectedStatus) {
      previouslySelectedStatus.isActive = false;
    }
    if (clickedStatus) {
      clickedStatus.isActive = !clickedStatus.isActive;

      if (clickedStatus.isActive) {
        this.selectedStatus = clickedStatus.value;
        this.getConsolidatedInvoices();
      } else {
        this.selectedStatus = null;
      }
    }
  }



  getColor(statusValue: string): string {
    switch (statusValue) {
      case 'PENDING':
        return '#E64F4F';
      case 'APPROVED_BY_CHECKER':
        return '#3351FF';
      case 'APPROVED_BY_LEAD':
        return '#08BD80';
      case 'DISAPPROVED':
        return '#FF9706';
      default:
        return '#FFFFFF';
    }
  }
  getConsolidatedStatus(filter: any = {}) {
    filter = {
      ...(this.fromDate && { from: DateTime.fromJSDate(this.fromDate).startOf("day").toUTC() }),
      ...(this.toDate && { to: DateTime.fromJSDate(this.toDate).endOf("day").toUTC() }),
    };

    this.http.post('status/CountConsolidate', filter, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          if (data != null) {
            const result = data.data;
            this.statuses.forEach((status) => {
              switch (status.value) {
                case 'PENDING':
                  status.count = (result.filter((ele) => ele._id === 'PENDING').map(x => x.sum)[0]) || 0;
                  status.total = (result.filter((ele) => ele._id === 'PENDING').map(x => x.Total)[0]) || 0;
                  break;
                case 'APPROVED_BY_CHECKER':
                  status.count = (result.filter((ele) => ele._id === 'APPROVED_BY_CHECKER').map(x => x.sum)[0]) || 0;
                  status.total = (result.filter((ele) => ele._id === 'APPROVED_BY_CHECKER').map(x => x.Total)[0]) || 0;
                  break;
                case 'APPROVED_BY_LEAD':
                  status.count = (result.filter((ele) => ele._id === 'APPROVED_BY_LEAD').map(x => x.sum)[0]) || 0;
                  status.total = (result.filter((ele) => ele._id === 'APPROVED_BY_LEAD').map(x => x.Total)[0]) || 0;
                  break;
                case 'DISAPPROVED':
                  status.count = (result.filter((ele) => ele._id === 'DISAPPROVED').map(x => x.sum)[0]) || 0;
                  status.total = (result.filter((ele) => ele._id === 'DISAPPROVED').map(x => x.Total)[0]) || 0;
                  break;
                // Add more cases for other status values if needed
                default:
                  break;
              }
            });
          }

        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

}
